import type { Prompt, PromptFolder } from ".";

export type ChatbotPrompts = ChatbotPrompt | ChatbotConversationStatePrompt | ChatbotNoSourcePrompt;

/* eslint-disable @typescript-eslint/naming-convention */
export const chatbotPromptFolders = {
	chatbot: "chatbot",
	"chatbot-conversation-state": "chatbot",
	"chatbot-no-source": "chatbot",
} as const satisfies Record<ChatbotPrompts["name"], PromptFolder>;
/* eslint-enable @typescript-eslint/naming-convention */

export interface ChatbotPrompt extends Prompt {
	name: "chatbot";
	variables: {
		botName: string;
		query: string;
		documents: string;
		language: string;
		customInstructions: string;
		responseSize: string;
		date: string;
		conversationState: string;
	};
}

export interface ChatbotConversationStatePrompt extends Prompt {
	name: "chatbot-conversation-state";
	variables: {
		conversationState: string;
		chatHistory: string;
		artifactContent: string;
	};
}

export interface ChatbotNoSourcePrompt extends Prompt {
	name: "chatbot-no-source";
	variables: {
		botName: string;
		query: string;
		language: string;
		date: string;
		chatHistory: string;
	};
}
